import store from "@/store";

export class Main
{
    public setLoaded(): void
    {
        console.log("EBI::Main::setLoaded");
        store.commit("setLoaded");
    }

    public setLoading(): void
    {
        console.log("EBI::Main::setLoading");
        store.commit("setLoading");
    }
}